import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async findAllModelosByUsuario ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `modeloDespacho/${dados.idUsuario}/findAllModelosByUsuario`
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/modelo.js